import React from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";

export default function Clubs() {
  return (
    <Layout>
      <div className="right-top">
        <div className="heading-top">
          <h2>Clubs</h2>
        </div>
        <hr />
        <Container fluid>
          <div className="cmn-top-fields">
            <Row>
              <Col xxl={3} xl={3} lg={4} md={4}>
                <Form.Group>
                  <Form.Control type="search" placeholder="Keyword Search.." />
                </Form.Group>
              </Col>

              <Col className="d-flex justify-content-end align-items-center">
                <div className="cmn-btn">
                  <Link to="#">DOWNLOAD CSV</Link>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
        <hr />
      </div>
      <Container fluid>
        <div className="results-sec">
          <Row>
            <Col lg={6} className="d-flex align-items-center">
              <div className="show-results">Showing 1 - 10 of 20 results</div>
            </Col>
            <Col lg={6}>
              <div className="select-result d-flex align-items-center justify-content-end">
                <span>Results per page</span>{" "}
                <Form.Select aria-label="Default select example">
                  <option>10</option>
                  <option value="1">11</option>
                  <option value="2">12</option>
                  <option value="3">13</option>
                </Form.Select>
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      <Container fluid className="px-0">
        <div class="table-responsive">
          <Table size="sm" className="table-cmn">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>FULL NAME</th>
                <th>EMAIL</th>
                <th>Contact number</th>
                <th>MESSAGE </th>
                <th>STATUS</th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>000001</td>
                <td>
                  01/02/2023
                  <br />
                  <span className="time">12:03</span>
                </td>
                <td>
                  <Link to="/Supportchat">Johnsmith@gmail.com</Link>
                </td>
                <td>Delete Account</td>
                <td>
                  I’m trying to delete my account. Could you please help ...
                </td>
                <td>Resolved</td>
                <td>
                  <div className="select-box">
                    <Form.Select aria-label="Default select example">
                      <option>Resolved</option>
                      <option value="1">Active</option>
                    </Form.Select>
                  </div>
                </td>
              </tr>
              <tr>
                <td>000001</td>
                <td>
                  01/02/2023
                  <br />
                  <span className="time">12:03</span>
                </td>
                <td>
                  <Link to="/Supportchat">Johnsmith@gmail.com</Link>
                </td>
                <td>Delete Account</td>
                <td>
                  I’m trying to delete my account. Could you please help ...
                </td>
                <td>Resolved</td>
                <td>
                  <div className="select-box">
                    <Form.Select aria-label="Default select example">
                      <option>Resolved</option>
                      <option value="1">Active</option>
                    </Form.Select>
                  </div>
                </td>
              </tr>
              <tr>
                <td>000001</td>
                <td>
                  01/02/2023
                  <br />
                  <span className="time">12:03</span>
                </td>
                <td>
                  <Link to="/Supportchat">Johnsmith@gmail.com</Link>
                </td>
                <td>Delete Account</td>
                <td>
                  I’m trying to delete my account. Could you please help ...
                </td>
                <td>Resolved</td>
                <td>
                  <div className="select-box">
                    <Form.Select aria-label="Default select example">
                      <option>Resolved</option>
                      <option value="1">Active</option>
                    </Form.Select>
                  </div>
                </td>
              </tr>
              <tr>
                <td>000001</td>
                <td>
                  01/02/2023
                  <br />
                  <span className="time">12:03</span>
                </td>
                <td>
                  <Link to="/Supportchat">Johnsmith@gmail.com</Link>
                </td>
                <td>Delete Account</td>
                <td>
                  I’m trying to delete my account. Could you please help ...
                </td>
                <td>Resolved</td>
                <td>
                  <div className="select-box">
                    <Form.Select aria-label="Default select example">
                      <option>Resolved</option>
                      <option value="1">Active</option>
                    </Form.Select>
                  </div>
                </td>
              </tr>
              <tr>
                <td>000001</td>
                <td>
                  01/02/2023
                  <br />
                  <span className="time">12:03</span>
                </td>
                <td>
                  <Link to="/Supportchat">Johnsmith@gmail.com</Link>
                </td>
                <td>Delete Account</td>
                <td>
                  I’m trying to delete my account. Could you please help ...
                </td>
                <td>Resolved</td>
                <td>
                  <div className="select-box">
                    <Form.Select aria-label="Default select example">
                      <option>Resolved</option>
                      <option value="1">Active</option>
                    </Form.Select>
                  </div>
                </td>
              </tr>
              <tr>
                <td>000001</td>
                <td>
                  01/02/2023
                  <br />
                  <span className="time">12:03</span>
                </td>
                <td>
                  <Link to="/Supportchat">Johnsmith@gmail.com</Link>
                </td>
                <td>Delete Account</td>
                <td>
                  I’m trying to delete my account. Could you please help ...
                </td>
                <td>Resolved</td>
                <td>
                  <div className="select-box">
                    <Form.Select aria-label="Default select example">
                      <option>Resolved</option>
                      <option value="1">Active</option>
                    </Form.Select>
                  </div>
                </td>
              </tr>
              <tr>
                <td>000001</td>
                <td>
                  01/02/2023
                  <br />
                  <span className="time">12:03</span>
                </td>
                <td>
                  <Link to="/Supportchat">Johnsmith@gmail.com</Link>
                </td>
                <td>Delete Account</td>
                <td>
                  I’m trying to delete my account. Could you please help ...
                </td>
                <td>Resolved</td>
                <td>
                  <div className="select-box">
                    <Form.Select aria-label="Default select example">
                      <option>Resolved</option>
                      <option value="1">Active</option>
                    </Form.Select>
                  </div>
                </td>
              </tr>
              <tr>
                <td>000001</td>
                <td>
                  01/02/2023
                  <br />
                  <span className="time">12:03</span>
                </td>
                <td>
                  <Link to="/Supportchat">Johnsmith@gmail.com</Link>
                </td>
                <td>Delete Account</td>
                <td>
                  I’m trying to delete my account. Could you please help ...
                </td>
                <td>Resolved</td>
                <td>
                  <div className="select-box">
                    <Form.Select aria-label="Default select example">
                      <option>Resolved</option>
                      <option value="1">Active</option>
                    </Form.Select>
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </Container>

      <div className="next-btn-fix">
        <Link to="#">Next</Link>
      </div>
    </Layout>
  );
}
